'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var V1 = exports.V1 = 'V1';
var HIDE_WIDGET = exports.HIDE_WIDGET = 'HIDE_WIDGET';
var RIGHT_ALIGNED = exports.RIGHT_ALIGNED = 'RIGHT_ALIGNED';